import { ChatContext }                      from '..'
import { ChatWsContext }                    from '..'
import { CardRoom }                         from '../card/CardRoom'
import { Link }                             from 'react-router-dom'

import React, {
    useContext,
    useEffect,
    useState
} from 'react'

import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    InputGroup,
    Input
} from 'reactstrap'

import {
    Edit,
    X,
    Archive,
    ArrowLeft
} from 'react-feather'

// API
import {
    getRoomByUUID,
    getRoomArchiveByUUID,
    markAsRead,
    markAsUnRead
} from '../../../../services/pages/chat/roomChat'

const SidebarLeft = (props) => {

    const { slug } = props

    // STATE
    const [type, set_type]                      = useState("")
    const [selectedRoom, setSelectedRoom]       = useState(0)
    const [roomComps, setRoomComps]             = useState(null)

    // CONTEXT
    const {
        visisibiltyContact,
        changeVisibilityRoom,
        setVisibilityModalContact,
        setVisibilityModalCreateGroup
    } = useContext(ChatContext)

    const {
        activeRoom, setActiveRoom,
        roomByUUID, setRoomByUUID,
        roomArchiveByUUID, setRoomArchiveByUUID,
        endConversation,
        archiveConversation,
        unArchiveConversation,
    } = useContext(ChatWsContext)

    useEffect(() => {
        set_type(slug)
        setSelectedRoom(null)
    }, [slug])

    useEffect(() => {
        handleGetRoom()
        handleGetRoomArchive()
    }, [type])

    function handleGetRoom() {
        getRoomByUUID().then((response) => {
            if (response.data != null) {
                setRoomByUUID(response.data)
            }
        })
    }

    function handleGetRoomArchive() {
        getRoomArchiveByUUID().then((response) => {
            if (response.data !== null) {
                setRoomArchiveByUUID(response.data)
            }
        })
    }

    function handleSelectRoom(userToChat) {
        setActiveRoom(userToChat)
        setSelectedRoom(userToChat.id)
        changeVisibilityRoom()
    }

    function handleMarkAsRead(id) {
        markAsRead(id)
            .then((response) => {
                handleGetRoom()
                handleGetRoomArchive()
            })
    }

    function handleMarkAsUnRead(id) {
        markAsUnRead(id)
            .then((response) => {
                handleGetRoom()
                handleGetRoomArchive()
            })
    }

    const handleSeachRoom = (keyword) => {
        if(keyword !== ""){
            if (type == "personal") {
                let newList = roomByUUID.filter((item) => item.name.toLowerCase().startsWith(keyword.toLocaleLowerCase()))
                handleRenderCard(newList)
            }else if (type == "group") {
                let newList = roomByUUID.filter((item) => item.name.toLowerCase().startsWith(keyword.toLocaleLowerCase()))
                handleRenderCard(newList)
            }else if (type == "personal-arsip") {
                let newList = roomArchiveByUUID.filter((item) => item.name.toLowerCase().startsWith(keyword.toLocaleLowerCase()))
                handleRenderCard(newList)
            }else if (type == "group-arsip") {
                let newList = roomArchiveByUUID.filter((item) => item.name.toLowerCase().startsWith(keyword.toLocaleLowerCase()))
                handleRenderCard(newList)
            }
        }else{
            RenderContacts()
        }
    }

    const handleRenderCard = (list, kind) => {
        let component = []
        if(list !== null) {
            list.map(val => {
                let activeType

                if(kind === "main"){
                    activeType = type
                }else{
                    activeType = type.split("-")[0]
                }

                if (val.type == activeType) {
                    let checkData
                    checkData = component.filter((item) => item.key === val.id)
                    
                    if(checkData.length < 1){
                        component.push(
                            cardRoomItem(val)
                        )
                    }
                }
            })
        }
        setRoomComps(component)
    }

    const RenderContacts = () => {
        if (type == "personal" || type == "group") {
            handleRenderCard(roomByUUID, "main")
        } else if (type == "personal-arsip" || type == "group-arsip") {
            handleRenderCard(roomArchiveByUUID, "arsip")
        }
    }

    const cardRoomItem = (val) => {
        return <CardRoom
            isActivate={activeRoom === null ? false : activeRoom.id === val.id ? true : false}
            item={{ ...val }}
            selected={activeRoom !== null ? activeRoom.id : 0}
            key={val.id}
            type={type}
            onSelectUser={() => { handleSelectRoom(val) }}
            endConversation={(id) => endConversation(id)}
            archiveConversation={(id) => archiveConversation(id)}
            unArchiveConversation={(id) => unArchiveConversation(id)}
            markAsRead={(id) => handleMarkAsRead(id)}
            markAsUnRead={(id) => handleMarkAsUnRead(id)}
        />
    }

    useEffect(() => {
        RenderContacts()
    },[roomByUUID])

    return (
        <div className={`'sidebar-left bg-white p-0 mr-1 shadow-sm col-lg-auto d-lg-block ' ${visisibiltyContact}`}
            style={{ width: '350px' }}>
            <div className='sidebar'>
                <div className='border-bottom' style={{ height: '110px' }}>
                    <div className='d-flex justify-content-between pt-2 px-2 mb-0'>
                        <div className='sidebar-toggle d-block d-lg-none me-1' onClick={() => changeVisibilityRoom(true)}>
                            <X size={21} className='cursor-pointer' />
                        </div>
                        <div>
                            <strong className='text-uppercase text-primary'>
                                {type}
                            </strong>
                        </div>
                        <div className='d-flex'>
                            {
                                type.split("-")[1] === undefined ? (
                                    <Link to={`/chat/${type.split("-")[0]}-arsip`} className="text-dark">
                                        <Archive size={20} className='cursor-pointer mr-1' />
                                    </Link>
                                ) : (
                                    <Link to={`/chat/${type.split("-")[0]}`} className="text-dark">
                                        <ArrowLeft size={20} className='cursor-pointer mr-1' />
                                    </Link>
                                )
                            }
                            <UncontrolledDropdown className="pt-0">
                                <DropdownToggle tag='span'>
                                    <Edit size={20} className='cursor-pointer' />
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem className='w-100' onClick={() => setVisibilityModalContact(true)}>
                                        <span className='align-middle'>Komunikasi Pribadi</span>
                                    </DropdownItem>
                                    <DropdownItem className='w-100' onClick={() => setVisibilityModalCreateGroup(true)}>
                                        <span className='align-middle'>Komunikasi Grup</span>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </div>

                    <div className='d-flex align-items-center pt-1 px-2 pb-1'>
                        <InputGroup className='input-group-merge w-100'>
                            <Input placeholder='Cari Percakapan...'
                                onChange={(e) => handleSeachRoom(e.target.value)}
                            />
                        </InputGroup>
                    </div>
                </div>

                <div className="pt-0 pb-2 m-0" style={{ overflow: 'auto', height: '90%' }}>
                    <ul className='chat-users-list contact-list media-list m-0 list-group list-group-flush rounded-0'>
                        {roomComps}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default SidebarLeft;